<!-- Query string 測試頁：/query_test -->
<template>
  <div class="layout_wrapper">
    <h5>clipboard test page</h5>

    <button
      class="copy_btn"
      :data-clipboard-text="queryStr"
    >
      複製 query string
    </button>
  </div>
</template>

<script>
import { computed, onMounted } from 'vue';
import ClipboardJS from 'clipboard';
import useCommon from '@/libs/globalComposition';

export default {
  name: 'CopyTest',
  components: {
  },
  setup () {
    const { currentRoute, store } = useCommon();
    const clipboard = new ClipboardJS('.copy_btn');

    const queryStr = computed(() => new URLSearchParams(currentRoute.query).toString());
    const dialogName = computed(() => store.state.dialog.modalName);

    onMounted(() => {
      clipboard.on('success', (e) => {
        console.log(e.text);
        alert('連結已複製');
        e.clearSelection();
      });
    });

    return {
      dialogName,
      queryStr
    };
  }
};
</script>

<style scoped lang="scss">
@import '@/scss/common/common.scss';

.layout_wrapper {
  text-align: center;
}

h5 {
  @include font-size-bold-18;

  margin: 20px 0px;
  text-align: center;
}

.copy_btn {
  background: $black;
  border: none;
  border-radius: 28.5px;
  box-shadow: 5px 7px 0px 0px $green;
  color: $white;
  cursor: pointer;
  display: inline-block;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  outline: none;
  padding: 16px 0px;
  width: 200px;
}
</style>
